import { render } from "./rsa_id_liveness_verification.html?vue&type=template&id=7955b6c9&external"
import script from "./rsa_id_liveness_verification.js?vue&type=script&lang=js&external"
export * from "./rsa_id_liveness_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__